import { IPaymentOfferModel } from "@nf/common";
import cx from "classnames";
import { useTranslation } from "next-i18next";
import dynamic from "next/dynamic";
import ChooseOfferButton from "./CardComponents/ChooseOfferButton";

import CheckmarkFilledIcon from "resources/checkmark-filled.svg";

const OfferPrice = dynamic(() => import("./CardComponents/OfferPrice"));

import styles from "./SimpleOfferCard.module.scss";

export interface SimpleOfferCardProps {
  offer: IPaymentOfferModel;
  active?: boolean;
  savings?: string;
  displayMode?: "choose" | "change";
  handleSelect?: (offerId: number, offerHandle: string) => void;
}

export const SimpleOfferCard = ({
  offer,
  active,
  savings,
  displayMode,
  handleSelect,
}: SimpleOfferCardProps) => {
  const { t } = useTranslation("translations");

  return (
    <div
      className={cx(styles.offer, styles.clickable, {
        [styles.active]: active,
      })}
      onClick={() => handleSelect?.(offer.Id, offer.Handle)}
    >
      {savings && <div className={styles.annualSave}>{savings}</div>}

      <OfferPrice
        price={offer.Price}
        period={offer.Period}
        savings={offer.SavingsPrice}
      />

      {displayMode === "change" && active ? (
        <div className={styles.voucher}>
          <CheckmarkFilledIcon /> {t("web_subscription_change_current_plan")}
        </div>
      ) : (
        handleSelect && <ChooseOfferButton offer={offer} />
      )}
    </div>
  );
};

export default SimpleOfferCard;
